/* Utils */
import {
  generateSelectEntityById,
  generateSelectEntitiesByIdsList,
  memoizeByRef,
} from '../utils/generators/selectorGenerators';

export const selectAllChannels = (state) => state.channels;

const selectChannelsBySourceProvider = memoizeByRef((channels, sourceProvider) => (
  channels.filter((channel) => channel.sourceProvider === sourceProvider)
));

export const selectAllChannelsBySourceProvider = (sourceProvider) => (state) => (
  selectChannelsBySourceProvider(selectAllChannels(state), sourceProvider)
);

export const selectChannelById = generateSelectEntityById(selectAllChannels);

export const selectChannelsListByIdsList = generateSelectEntitiesByIdsList(selectAllChannels);
